<template>
  <!-- -->
  <div class="data-card">
    <form-items label-width="2.4rem" :columns="1">
      <div v-if="showText">
        <form-item label="文本名称">
          <el-input v-model="value.text" placeholder="请输入文本内容" @change="changeData"/>
        </form-item>
        <form-item label="文本大小" desc-message="通用字体大小为一般为24、28两个尺寸">
          <el-input-number style="width: 100%" v-model="value.fontSize" placeholder="请输入文本大小" @change="changeFontSize"/>
        </form-item>
        <form-item label="对齐方式">
          <el-select v-model="value.textAlign" placeholder="请选择对齐方式" @change="changeData">
            <el-option label="左对齐" value="left"/>
            <el-option label="居中" value="center"/>
            <el-option label="右对齐" value="right"/>
          </el-select>
        </form-item>
        <form-item label="颜色和背景">
          <el-color-picker v-model="value.textColor" show-alpha @change="changeData"/>
          <el-color-picker v-model="value.textBackground" show-alpha @change="changeData"/>
        </form-item>
      </div>
      <form-item label="设置图标" v-if="showIcon">
        <el-input readonly v-model="value.itemIcon" placeholder="请选择图标" @click="toSelectIcon">
          <template #suffix>
            <yq-icon v-if="value.itemIcon" :name="value.itemIcon"/>
            <yq-icon v-else name="element-ui_arrow-down"/>
          </template>
        </el-input>
      </form-item>
      <form-item label="设置图片" v-if="showImage">
        <image-upload v-model="value.itemImage2" @data-change="imageChange" folder="miniSetting" :limit="1" :accept="'image/*'" :upload-tips="`上传尺寸建议${value.size}`" :show-folder-manage="true"/>
      </form-item>
      <form-item label="设置背景色" v-if="showBackground">
        <el-color-picker v-model="value.itemBackground" show-alpha @change="changeData"/>
      </form-item>
      <div v-if="showTag">
        <form-item label="标签">
          <el-input v-model="value.tagName" placeholder="请输入标签" @change="changeData"/>
        </form-item>
        <form-item label="颜色和背景">
          <el-color-picker v-model="value.tagColor" show-alpha @change="changeData"/>
          <el-color-picker v-model="value.tagBackground" show-alpha @change="changeData"/>
        </form-item>
      </div>
      <div v-if="showPath">
        <form-item label="跳转功能">
          <el-select v-model="value.pathType" placeholder="请选择跳转功能" @change="changePathType">
            <el-option v-for="item in miniPageName" :key="item.pageType" :value="item.pageType" :label="item.pageName"/>
          </el-select>
        </form-item>
        <form-item label="跳转路由">
          <el-input v-model="value.path" placeholder="请输入路由"/>
        </form-item>
        <form-item label="跳转参数">
          <el-input v-model="value.pathValue" placeholder="请输入跳转参数"/>
        </form-item>
        <form-item label="参数选择" v-if="showChooseBtn()">
          <!-- 商品详情：选择主商品 -->
          <product-select v-if="pathType === '1'"
                          v-model="paramId"
                          :multi="false"
                          :query-api="queryMainProductList"
                          label="商品"
                          title="选择主商品"
                          placeholder="请选择主商品" style="width: 100%"/>
          <!-- 商品列表：选择一级商品分类 -->
          <el-select v-else-if="pathType === '2'" v-model="paramId" placeholder="请选择一级商品分类"
                     clearable filterable style="width: 100%">
            <el-option v-for="item in categoryOptions" :key="item.dictCode"
                       :label="item.dictName" :value="item.dictCode"/>
          </el-select>
          <!-- 小程序信息：弹窗选择没有下级的信息 -->
          <el-input v-else-if="pathType === '3'" readonly :value="selectedInfoTitle"
                    placeholder="请选择小程序信息" @click="openInfoDialog">
            <template #suffix>
              <yq-icon name="element-ui_arrow-down"/>
            </template>
          </el-input>
          <!-- 小程序信息列表：选择有下级的一级信息 -->
          <el-select v-else-if="pathType === '4'" v-model="paramId" placeholder="请选择一级小程序信息"
                     clearable filterable style="width: 100%">
            <el-option v-for="item in infoRootOptions" :key="item.id"
                       :label="item.informationTitle" :value="item.id"/>
          </el-select>
        </form-item>
        <form-item label="备注信息">
          <el-input v-model="value.remark" placeholder="请输入备注"/>
        </form-item>
      </div>
    </form-items>
    <el-dialog v-model="showIconList" title="请选择图标" dialog-width="2" append-to-body>
      <el-input v-model="iconFilterKey" placeholder="请输入图标名称过滤" @keyup="filterIcon" clearable />
      <dialog-table>
        <div v-for="(item, i) in iconList2" :key="i" class="dialog-icon" :class="selectedIcon === item? 'icon-on': ''" @click="selectIcon(item)">
          <yq-icon  class="dialog-icon-item" :name="item"/>
          <div class="dialog-icon-text">{{item}}</div>
        </div>
      </dialog-table>
      <template #footer>
        <page-button @click="showIconList = false">取消</page-button>
        <page-button @click="selectIcon2Save" el-type="primary" >确定</page-button>
      </template>
    </el-dialog>

    <!-- 小程序信息选择：有下级的数据是分类，只允许选择叶子节点 -->
    <el-dialog v-model="showInfoDialog" title="选择小程序信息" dialog-width="2"
               append-to-body :close-on-click-modal="false">
      <el-input v-model="infoFilterKey" placeholder="输入标题过滤" clearable style="margin-bottom: 10px"/>
      <dialog-table>
        <el-table :data="filteredInfoLeaves" border size="small" height="420"
                  empty-text="暂无可选信息" @row-dblclick="chooseInfo">
          <el-table-column label="标题" prop="informationTitle" min-width="220" :show-overflow-tooltip="true"/>
          <el-table-column label="副标题" prop="subTitle" min-width="160" :show-overflow-tooltip="true">
            <template #default="{row}">{{ row.subTitle || '—' }}</template>
          </el-table-column>
          <el-table-column label="上级" prop="parentTitle" min-width="160" :show-overflow-tooltip="true">
            <template #default="{row}">{{ row.parentTitle || '—' }}</template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center">
            <template #default="{row}">
              <el-button type="primary" link @click.stop="chooseInfo(row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </dialog-table>
      <template #footer>
        <page-button @click="showInfoDialog = false">取消</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>


import {watch} from "vue";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqIcon from "@/components/YqIcon.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import ProductSelect from "@/components/h5/product/ProductSelect.vue";
import commonApi from "@/api/commonApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import miniInformationApi from "@/api/normal/sys/miniInformationApi";
import config from "@/config/config";

// 商品分类、小程序信息树是全局数据，多个参数配置项共用，避免每个组件重复请求
let categoryCache = null;
let infoTreeCache = null;

export default {
  emits: ["change"],
  props: {
    modelValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showText: {default: true}, // 显示文本
    showIcon: {default: true}, // 显示图标
    showImage: {default: true}, // 显示图片
    showTag: {default: true}, // 显示标签
    showBackground: {default: true}, // 可选背景颜色
    showPath: {default: true}, // 显示跳转功能
  },
  name: "",
  components: {
    DialogTable,
    ProductSelect,
    YqIcon,
    TableButton,
    ImageUpload, FormItems, FormItem
  },
  data() {
    return {
      value: {
        itemIcon: "",
        itemColor: "",
        itemImage: "",
        itemImage2: "", // 只用于图片上传组件
        itemBackground: "",
        // 文本
        text: "",
        textColor: "",
        textBackground: "",
        textAlign: "",

        // 标签
        tagName: "",
        tagColor: "",
        tagBackground: "",
        // 链接
        path: "",
        pathType: "",
        pathValue: "",
        // 下级
        children: []
      },
      miniPageName: [
        {pageName: "商品详情页", pageType: "1"},
        {pageName: "商品列表页", pageType: "2"},
        {pageName: "小程序信息页", pageType: "3"},
        {pageName: "小程序信息列表", pageType: "4"},
        {pageName: "其它页面", pageType: "99"},
      ],
      miniPagePath: {
        "1": "/pages/product/ProductDetail",
        "2": "/pages/product/ProductList",
        "3": "/pages/info/InfoDetail",
        "4": "/pages/info/InfoList",
        "99": "",
      },
      iconList: config.iconList,
      iconList2: [],
      iconFilterKey: "",
      showIconList: false,
      selectedIcon: "",
      // 跳转参数选择
      categoryOptions: [],
      infoTree: [],
      showInfoDialog: false,
      infoFilterKey: "",
    };
  },
  computed: {
    pathType() {
      return String((this.value && this.value.pathType) || "");
    },
    // 跳转参数统一为 id=xxx，选择器直接读写这个 id
    paramId: {
      get() {
        return this.getPathValue("id");
      },
      set(value) {
        this.setPathValue("id", value);
      },
    },
    // 有下级的一级小程序信息，用于信息列表页
    infoRootOptions() {
      return (this.infoTree || []).filter(item => item.children && item.children.length);
    },
    // 没有下级的叶子信息，用于信息详情页
    infoLeaves() {
      return this.flattenInfo(this.infoTree || []);
    },
    filteredInfoLeaves() {
      const key = (this.infoFilterKey || "").trim();
      if (!key) {
        return this.infoLeaves;
      }
      return this.infoLeaves.filter(item =>
          (item.informationTitle || "").indexOf(key) > -1
          || (item.subTitle || "").indexOf(key) > -1);
    },
    // id -> 标题，用于回显已选信息
    infoTitleMap() {
      const map = {};
      const walk = nodes => {
        (nodes || []).forEach(node => {
          map[node.id] = node.informationTitle || "";
          walk(node.children);
        });
      };
      walk(this.infoTree);
      return map;
    },
    selectedInfoTitle() {
      if (!this.paramId) {
        return "";
      }
      return this.infoTitleMap[this.paramId] || this.paramId;
    },
  },
  created() {
    this.init();
    watch(() => this.modelValue, () => this.init())
  },
  methods: {
    // 是否显示选择数据的按钮
    showChooseBtn() {
      return ["1", "2", "3", "4"].indexOf(this.pathType) > -1;
    },
    changePathType(val) {
      this.value.path = this.miniPagePath[val] || "";
      // 切换功能后旧的 id 已不适用，保留其它手工参数
      if (["1", "2", "3", "4"].indexOf(String(val)) > -1) {
        this.setPathValue("id", "");
        this.ensureOptions(val);
      }
      this.changeData();
    },
    init() {
      this.value = this.modelValue || {};
      this.ensureOptions(this.pathType);
    },
    // 商品详情只允许选择主商品，不能使用下单用的 SKU 商品列表接口
    queryMainProductList(data) {
      return commonDataApi.queryMainProductList(data);
    },
    // 按跳转类型懒加载选择数据，多个组件共用同一份缓存
    ensureOptions(type) {
      const value = String(type || "");
      if (value === "2") {
        this.loadCategories();
      } else if (value === "3" || value === "4") {
        this.loadInfoTree();
      }
    },
    async loadCategories() {
      if (this.categoryOptions.length) {
        return;
      }
      if (!categoryCache) {
        categoryCache = commonApi.queryDictionaryTree("PRODUCT_CATEGORY").catch(e => {
          categoryCache = null;
          return [];
        });
      }
      this.categoryOptions = await categoryCache || [];
    },
    async loadInfoTree() {
      if (this.infoTree.length) {
        return;
      }
      if (!infoTreeCache) {
        infoTreeCache = miniInformationApi.queryTree().catch(e => {
          infoTreeCache = null;
          return [];
        });
      }
      this.infoTree = await infoTreeCache || [];
    },
    // 拍平信息树，只保留没有下级的可选项；parentTitle 用于弹窗展示
    flattenInfo(nodes, parentTitle) {
      let result = [];
      (nodes || []).forEach(node => {
        const children = node.children || [];
        if (children.length) {
          result = result.concat(this.flattenInfo(children, node.informationTitle || ""));
        } else {
          result.push({...node, parentTitle: parentTitle || ""});
        }
      });
      return result;
    },
    async openInfoDialog() {
      await this.loadInfoTree();
      this.infoFilterKey = "";
      this.showInfoDialog = true;
    },
    chooseInfo(row) {
      if (!row) {
        return;
      }
      this.paramId = row.id;
      this.showInfoDialog = false;
    },
    // 从 pathValue 中读取参数
    getPathValue(key) {
      const text = String((this.value && this.value.pathValue) || "").replace(/^\?/, "");
      const parts = text ? text.split("&") : [];
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const index = part.indexOf("=");
        const name = index < 0 ? part : part.substring(0, index);
        if (name === key) {
          const value = index < 0 ? "" : part.substring(index + 1);
          try {
            return decodeURIComponent(value);
          } catch (e) {
            return value;
          }
        }
      }
      return "";
    },
    // 更新 pathValue 中的某个参数，保留其它手工参数
    setPathValue(key, value) {
      if (!this.value) {
        return;
      }
      const text = String(this.value.pathValue || "").replace(/^\?/, "");
      const parts = text ? text.split("&").filter(Boolean) : [];
      const kept = parts.filter(part => {
        const index = part.indexOf("=");
        const name = index < 0 ? part : part.substring(0, index);
        return name !== key;
      });
      if (value !== undefined && value !== null && String(value) !== "") {
        kept.push(`${key}=${value}`);
      }
      this.value.pathValue = kept.join("&");
      this.changeData();
    },
    // 数据变更
    changeData() {
      this.$emit("change", this.value);
    },
    imageChange() {
      if (this.value.itemImage2) {
        let json = JSON.parse(this.value.itemImage2);
        this.value.itemImage = json[0].url;
      }
      this.$emit("change", this.value);
    },
    // 文本大小变更
    changeFontSize() {
      this.value.textSize = this.value.fontSize / 47 + "rem";
      this.changeData();
    },
    // 开始选择图标
    toSelectIcon() {
      this.selectedIcon = this.value.itemIcon;
      this.iconList2 = this.iconList;
      this.showIconList = true;
    },
    filterIcon() {
      let value = this.iconFilterKey;
      this.iconList2 = this.iconList.filter(item => item.indexOf(value) > -1);
    },
    // 选中某个图标
    selectIcon(icon) {
      this.selectedIcon = icon;
    },
    // 选中某个图标，确认
    selectIcon2Save() {
      this.value.itemIcon = this.selectedIcon;
      this.showIconList = false;
      this.changeData();
    },
  }
};
</script>

<style lang="scss" scoped>
.data-card{
  background-color: #FFF;
  border: 1px solid var(--yq-border-color);
  margin-top: 10px;
  border-radius: 6px;
  padding: 10px;
}
.dialog-icon{
  font-size: 12px;
  width: 100px;
  display: inline-block;
  margin-bottom: 10px;
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  .dialog-icon-item{
    font-size: 24px;

  }
  &.icon-on{
    color: #FFF;
    background: var(--el-color-primary);
  }
  .dialog-icon-text{
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>